import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  TextareaAutosize,
} from "@mui/material";

import { searchfetchQueries } from "../../../../../services/BackendServices";

// Tab 2: Commodity Details
const CommodityDetailsTab = ({
  setLoading,
  category,
  setCategory,
  product,
  setProduct,
  hsCode,
  setHsCode,
  grade,
  setGrade,
  variety,
  setVariety,
  productSpecifications,
  setProductSpecifications,
  origin,
  setOrigin,
  additionalProductNotes,
  setAdditionalProductNotes,
  productCategoryMaster,
  setProductCategoryMaster,
  filteredProductList,
  productGradeList,
  countrymaster,
  loadProducts,
  loadProductGrades,
  loadFormProductInfo,
  errors,
  isViewMode,
  allProductMaster,
}) => {

  //   const [productCategoryMaster, setProductCategoryMaster] = useState([]);
  const handleCategoryChange = useCallback(
    (e) => {
      if (!isViewMode) {
        setCategory(e.target.value);
        loadProducts(e.target.value);
        setProduct("");
        setGrade("");
      }
    },
    [setCategory, loadProducts, setProduct, setGrade, isViewMode]
  );

  const handleProductChange = useCallback(
    (e) => {
      if (!isViewMode) {
        setProduct(e.target.value);
        loadProductGrades(e.target.value);
        setGrade("");
      }
    },
    [setProduct, loadProductGrades, setGrade, isViewMode]
  );

  const handleGradeChange = useCallback(
    (e) => {
      if (!isViewMode) {
        setGrade(e.target.value);
        loadFormProductInfo(product, e.target.value);
      }
    },
    [setGrade, loadFormProductInfo, product, isViewMode]
  );

  //master load
  const loadProductCategories = useCallback(async () => {
    setLoading(true);
    try {
      const [allProductCats] = await Promise.all([
        searchfetchQueries({
          target: "listProductCategory",
          userOrder: "CategoryName",
          rowStart: 0,
          pageSize: 100,
        }),
      ]);
      setProductCategoryMaster(allProductCats);
    } catch (error) {
      console.error("Error loading product categories: ", error);
      setProductCategoryMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    if(!isViewMode){
      loadProductCategories(); 
    }
  }, [loadProductCategories]);

  const getCategoryName = () => {
    const cat = allProductMaster.find(
      (p) => p.ProductCategoryID === category
    );
    return cat?.CategoryName || "";
  };

  return (
    <div className="row g-3">
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }} error={!!errors.category}>
          <Typography variant="body2">Commodity Category *</Typography>
          {isViewMode ? (
            <TextField
              value={getCategoryName()}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="category selected"
            />
          ) : (
          <Select
            value={category}
            onChange={handleCategoryChange}
            displayEmpty
            sx={{ backgroundColor: "white" }}
            disabled={isViewMode}
          >
            <MenuItem value="" disabled>
              Select Category
            </MenuItem>
            {productCategoryMaster.map((p) => (
              <MenuItem key={p.ProductCategoryID} value={p.ProductCategoryID}>
                {p.CategoryName}
              </MenuItem>
            ))}
          </Select>
          )}
          {errors.category && (
            <Typography variant="caption" color="error">
              {errors.category}
            </Typography>
          )}
        </FormControl>
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }} error={!!errors.product}>
          <Typography variant="body2">Commodity/Product Name *</Typography>
          {isViewMode ? (
            <TextField
              value={product}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No product selected"
            />
          ) : (
          <Select
            value={product}
            onChange={handleProductChange}
            displayEmpty
            sx={{ backgroundColor: "white" }}
            disabled={isViewMode}
          >
            <MenuItem value="" disabled>
              Select Product
            </MenuItem>
            {Array.from(
              new Set(filteredProductList.map((p) => p.ProductName))
            ).map((productName, index) => (
              <MenuItem key={index} value={productName}>
                {productName}
              </MenuItem>
            ))}
          </Select>
          )}
          {errors.product && (
            <Typography variant="caption" color="error">
              {errors.product}
            </Typography>
          )}
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl sx={{ minWidth: "100%" }} error={!!errors.grade}>
          <Typography variant="body2">Grade/Quality *</Typography>
          {isViewMode ? (
            <TextField
              value={grade}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No grade selected"
            />
          ) : (
          <Select
            value={grade}
            onChange={handleGradeChange}
            displayEmpty
            sx={{ backgroundColor: "white" }}
            disabled={isViewMode}
          >
            <MenuItem value="" disabled>
              Select Grade
            </MenuItem>
            {productGradeList.map((p) => (
              <MenuItem key={p.ProductID} value={p.Grade}>
                {p.Grade}
              </MenuItem>
            ))}
          </Select>
          )}
          {errors.grade && (
            <Typography variant="caption" color="error">
              {errors.grade}
            </Typography>
          )}
        </FormControl>
      </div>
      <div className="col-md-4">
        <Typography variant="body2">HS Code</Typography>
        <TextField
          value={hsCode}
          onChange={(e) => !isViewMode && setHsCode(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          placeholder="Enter HS Code"
          disabled={true}
        />
      </div>

      <div className="col-md-4">
        <Typography variant="body2">Variety</Typography>
        <TextField
          value={variety}
          onChange={(e) => !isViewMode && setVariety(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          placeholder="Enter Variety"
          disabled={true}
        />
      </div>
      <div className="col-md-6">
        <Typography variant="body2">Product Specifications</Typography>
        <TextareaAutosize
          value={productSpecifications}
          onChange={(e) =>
            !isViewMode && setProductSpecifications(e.target.value)
          }
          style={{
            backgroundColor: "white",
            width: "100%",
            minHeight: "56px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontFamily: "inherit",
            fontSize: "14px",
            resize: "vertical",
          }}
          minRows={2}
          placeholder="Enter specifications (moisture %, protein %, etc.)"
          disabled={isViewMode}
        />
      </div>
      <div className="col-md-6">
        <Typography variant="body2">Origin Preference *</Typography>
        <FormControl sx={{ minWidth: "100%" }}>
        {isViewMode ? (
            <TextField
              value={origin}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No origin selected"
            />
          ) : (
          <Select
            value={origin}
            onChange={(e) => !isViewMode && setOrigin(e.target.value)}
            displayEmpty
            sx={{ backgroundColor: "white" }}
            disabled={isViewMode}
          >
            <MenuItem value="">Select Origin Country</MenuItem>
            {countrymaster.map((c) => (
              <MenuItem key={c.ID} value={c.Value}>
                {c.Value}
              </MenuItem>
            ))}
          </Select>
          )}
          {errors.origin && (
            <Typography variant="caption" color="error">
              {errors.origin}
            </Typography>
          )}
        </FormControl>
      </div>
      <div className="col-md-12">
        <Typography variant="body2">Additional Product Notes</Typography>
        <TextareaAutosize
          value={additionalProductNotes}
          onChange={(e) =>
            !isViewMode && setAdditionalProductNotes(e.target.value)
          }
          style={{
            backgroundColor: "white",
            width: "100%",
            minHeight: "56px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontFamily: "inherit",
            fontSize: "14px",
            resize: "vertical",
          }}
          minRows={2}
          placeholder="Enter additional product notes"
          disabled={isViewMode}
        />
      </div>
    </div>
  );
};
export default CommodityDetailsTab;
